import React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "antd";
import { isSuperAdmin } from "../../utils/isSuperAdmin";
import userStore from "../../store/userStore";
import BaseSearch from "../../components/reusable/baseSearch/BaseSearch";

interface IVenuesSearch {
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  createBlog: () => void;
}
const BlogsSearch: React.FC<IVenuesSearch> = observer(({ setSearch, createBlog }) => {
  return (
    <div className={"base-page-header blog-page-actions gap-20"}>
      <BaseSearch handleChange={(value) => setSearch(value)} />
      {isSuperAdmin(userStore.user) ? (
        <>
          <div className={"d-flex-aligned-end blog-page-actions-btn"}>
            <Button type="primary" size="large" onClick={createBlog}>
              Add Blog
            </Button>
          </div>
        </>
      ) : null}
    </div>
  );
});

export default BlogsSearch;
